jQuery( document ).ready( function ( $ ) {
  var module_name = 'cards';
  $('.clear-date-icon').click(function (e) {
    $('#card-input-date').val('');
    $('#filter-card').submit();
  });

  // Tips toggle functionality - using same logic as followers (no AJAX)
  $('.tabs-list-tips li a').on('click', function(e) {
    e.preventDefault();
  });
  $('.tabs-list-tips li').on('click', function() {
    var tabid = $(this).find("a").attr("href");
    $(".tabs-list-tips li,.cards-module div.tab-tips").removeClass("active"); // removing active class from tab

    $(".tab-tips").hide(); // hiding open tab
    $(tabid).show(); // show tab
    $(this).addClass("active"); //  adding active class to clicked tab
  });

  initCardsCarousels();
} );

/**
 * Cards carousel — only runs when View Type is "Carousel".
 * Matches Figma Carousel/Desktop1: bottom nav + green pill dots.
 * Normal card grids are left untouched.
 */
function initCardsCarousels() {
  var carousels = document.querySelectorAll('[data-cards-carousel]');
  if (!carousels.length) {
    return;
  }

  carousels.forEach(function (carousel) {
    setupCardsCarousel(carousel);
  });
}

function setupCardsCarousel(carousel) {
  var viewport = carousel.querySelector('.cards-carousel__viewport');
  var controls = carousel.querySelector('.cards-carousel__controls');
  var prevBtn = carousel.querySelector('.cards-carousel__nav--prev');
  var nextBtn = carousel.querySelector('.cards-carousel__nav--next');
  var dotsEl = carousel.querySelector('.cards-carousel__dots');
  if (!viewport || !prevBtn || !nextBtn || !dotsEl) {
    return;
  }

  var track = findCardsCarouselTrack(viewport);
  if (!track) {
    return;
  }

  var slides = Array.prototype.slice.call(track.children).filter(function (el) {
    return el.nodeType === 1;
  });

  if (!slides.length) {
    if (controls) {
      controls.style.display = 'none';
    }
    return;
  }

  track.classList.add('cards-carousel__track');
  slides.forEach(function (slide) {
    slide.classList.add('cards-carousel__slide');
  });

  if (track.parentElement) {
    track.parentElement.classList.add('cards-carousel__overflow');
  }

  var currentIndex = 0;
  var gap = 16;
  var cardWidthDesktop = 280;
  var isAnimating = false;
  var resizeTimer = null;
  var pointerStartX = 0;
  var pointerDeltaX = 0;
  var isDragging = false;
  var pendingDrag = false;
  var dragMoved = false;
  var activePointerId = null;
  var MAX_VISIBLE_DOTS = 5;
  var DRAG_ACTIVATE = 12;

  function getSlideWidth() {
    var viewportWidth = viewport.offsetWidth;
    if (viewportWidth <= 480) {
      return viewportWidth;
    }
    if (viewportWidth <= 768) {
      // ~2 cards + peek
      return Math.min(cardWidthDesktop, (viewportWidth - gap) / 2.2);
    }
    // Desktop: ~280px cards with peek of next (Figma Desktop1)
    return cardWidthDesktop;
  }

  function getVisibleFloat() {
    var slideWidth = getSlideWidth();
    return (viewport.offsetWidth + gap) / (slideWidth + gap);
  }

  function getMaxIndex() {
    return Math.max(0, Math.ceil(slides.length - getVisibleFloat()));
  }

  function getDotCount(pageCount) {
    return Math.min(MAX_VISIBLE_DOTS, pageCount);
  }

  function pageToDotIndex(pageIndex, maxIndex, dotCount) {
    if (maxIndex <= 0 || dotCount <= 1) {
      return 0;
    }
    return Math.round((pageIndex / maxIndex) * (dotCount - 1));
  }

  function dotIndexToPage(dotIndex, maxIndex, dotCount) {
    if (dotCount <= 1) {
      return 0;
    }
    return Math.round((dotIndex / (dotCount - 1)) * maxIndex);
  }

  function renderDots() {
    var maxIndex = getMaxIndex();
    var pageCount = maxIndex + 1;
    var showNav = pageCount > 1;

    if (controls) {
      controls.style.display = showNav ? '' : 'none';
    }
    carousel.classList.toggle('cards-carousel--has-nav', showNav);

    // Looping carousel — arrows stay enabled whenever there is more than one page
    prevBtn.disabled = !showNav;
    nextBtn.disabled = !showNav;

    if (!showNav) {
      dotsEl.innerHTML = '';
      dotsEl.removeAttribute('aria-valuenow');
      return;
    }

    var dotCount = getDotCount(pageCount);
    var activeDot = pageToDotIndex(currentIndex, maxIndex, dotCount);
    var html = '';

    for (var i = 0; i < dotCount; i++) {
      html += '<button type="button" class="cards-carousel__dot' +
        (i === activeDot ? ' is-active' : '') +
        '" data-dot="' + i + '" aria-label="Go to position ' + (i + 1) + ' of ' + dotCount + '"' +
        (i === activeDot ? ' aria-current="true"' : '') +
        '></button>';
    }

    dotsEl.innerHTML = html;
    dotsEl.setAttribute('aria-valuemin', '1');
    dotsEl.setAttribute('aria-valuemax', String(pageCount));
    dotsEl.setAttribute('aria-valuenow', String(currentIndex + 1));
    dotsEl.setAttribute('aria-label', 'Carousel page ' + (currentIndex + 1) + ' of ' + pageCount);
  }

  function update() {
    var maxIndex = getMaxIndex();
    if (maxIndex <= 0) {
      currentIndex = 0;
    } else if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    } else if (currentIndex < 0) {
      currentIndex = 0;
    }

    var slideWidth = getSlideWidth();

    slides.forEach(function (slide) {
      slide.style.flex = '0 0 ' + slideWidth + 'px';
      slide.style.width = slideWidth + 'px';
      slide.style.maxWidth = slideWidth + 'px';
      slide.style.minWidth = slideWidth + 'px';
    });

    var offset = currentIndex * (slideWidth + gap);
    track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';

    renderDots();
  }

  function goTo(index) {
    if (isAnimating) {
      return;
    }
    var maxIndex = getMaxIndex();
    if (maxIndex <= 0) {
      return;
    }

    // Infinite loop: wrap past the ends
    var nextIndex = index;
    if (index > maxIndex) {
      nextIndex = 0;
    } else if (index < 0) {
      nextIndex = maxIndex;
    }

    if (nextIndex === currentIndex) {
      update();
      return;
    }
    isAnimating = true;
    currentIndex = nextIndex;
    update();
    window.setTimeout(function () {
      isAnimating = false;
    }, 350);
  }

  function endDrag() {
    var wasDragging = isDragging;
    var delta = pointerDeltaX;

    isDragging = false;
    pendingDrag = false;
    activePointerId = null;
    track.classList.remove('is-dragging');
    track.style.transition = '';
    pointerDeltaX = 0;

    if (!wasDragging) {
      return;
    }

    var threshold = 50;
    if (delta > threshold) {
      goTo(currentIndex - 1);
    } else if (delta < -threshold) {
      goTo(currentIndex + 1);
    } else {
      update();
    }
  }

  prevBtn.addEventListener('click', function () {
    goTo(currentIndex - 1);
  });

  nextBtn.addEventListener('click', function () {
    goTo(currentIndex + 1);
  });

  dotsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.cards-carousel__dot');
    if (!btn) {
      return;
    }
    var maxIndex = getMaxIndex();
    var pageCount = maxIndex + 1;
    var dotCount = getDotCount(pageCount);
    var dotIndex = parseInt(btn.getAttribute('data-dot'), 10);
    goTo(dotIndexToPage(dotIndex, maxIndex, dotCount));
  });

  // Desktop + touch drag (Pointer Events)
  // Drag only activates after moving past a threshold so links/buttons stay clickable.
  track.style.cursor = 'grab';
  track.style.touchAction = 'pan-y';

  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) {
      return;
    }
    if (getMaxIndex() <= 0) {
      return;
    }
    // Don't hijack form controls
    if (e.target.closest('input, select, textarea, label')) {
      return;
    }

    pendingDrag = true;
    isDragging = false;
    dragMoved = false;
    activePointerId = e.pointerId;
    pointerStartX = e.clientX;
    pointerDeltaX = 0;
  });

  track.addEventListener('pointermove', function (e) {
    if ((!pendingDrag && !isDragging) || e.pointerId !== activePointerId) {
      return;
    }

    pointerDeltaX = e.clientX - pointerStartX;

    // Activate drag only after intentional movement — keeps clicks working
    if (!isDragging && Math.abs(pointerDeltaX) >= DRAG_ACTIVATE) {
      isDragging = true;
      dragMoved = true;
      pendingDrag = false;
      track.style.transition = 'none';
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {
        // ignore
      }
    }

    if (!isDragging) {
      return;
    }

    var slideWidth = getSlideWidth();
    var baseOffset = currentIndex * (slideWidth + gap);
    track.style.transform = 'translate3d(-' + (baseOffset - pointerDeltaX) + 'px, 0, 0)';
  });

  track.addEventListener('pointerup', function (e) {
    if (e.pointerId !== activePointerId) {
      return;
    }
    if (isDragging) {
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {
        // ignore
      }
    }
    endDrag();
  });

  track.addEventListener('pointercancel', function (e) {
    if (e.pointerId !== activePointerId) {
      return;
    }
    endDrag();
  });

  // Only block link clicks when the user actually dragged the carousel
  track.addEventListener('click', function (e) {
    if (dragMoved) {
      e.preventDefault();
      e.stopPropagation();
      dragMoved = false;
    }
  }, true);

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(update, 150);
  });

  // Recalculate after images load so widths stay correct
  var images = track.querySelectorAll('img');
  var pending = images.length;
  if (pending) {
    images.forEach(function (img) {
      if (img.complete) {
        pending -= 1;
        if (!pending) {
          update();
        }
      } else {
        img.addEventListener('load', function () {
          pending -= 1;
          if (!pending) {
            update();
          }
        });
        img.addEventListener('error', function () {
          pending -= 1;
          if (!pending) {
            update();
          }
        });
      }
    });
  }

  update();
}

function findCardsCarouselTrack(viewport) {
  var selectors = [
    '.bookmaker-cards',
    '.blogg-cards',
    '.payment-cards',
    '.article-cards',
    '.tip-cards > .row',
    '.tip-secondary-cards',
    '.slot-card'
  ];

  for (var i = 0; i < selectors.length; i++) {
    var found = viewport.querySelector(selectors[i]);
    if (found && found.children.length) {
      return found;
    }
  }

  // Fallback: first element with multiple direct children
  var candidates = viewport.querySelectorAll('div');
  for (var j = 0; j < candidates.length; j++) {
    var el = candidates[j];
    if (el.children.length > 1 && !el.querySelector('.title')) {
      return el;
    }
  }

  return null;
}
